import { _ as _objectWithoutProperties, d as deepMerge } from './deep-merge-c6cfd18c.js';
import { shadows } from './shadows.js';
import { createThemeGrid } from './create-theme-grid.js';
import '@vebox/etui-colors';
import createThemePalette from './create-theme-palette.js';
import { createThemeSpacing } from './create-theme-spacing.js';
import { createThemeTypography } from './create-theme-typography.js';
import { createThemeBreakpoints } from './create-theme-breakpoints.js';

const _excluded = ["palette", "spacing", "typography", "grid", "breakpoints"];
const shape = {
  borderRadius: 2,
  inputHeight: 50,
  inputHeightSmall: 42,
  headerTopHeight: 60,
  headerBottomHeight: 50,
  commandBarHeight: 50,
  tabsHeight: 50
};
const zIndex = {
  commandBar: 3,
  modal: 5,
  multiSwitcher: 1,
  header: 4,
  selectInput: 2,
  selectMenu: 11
};
function createTheme(overrides = {}, ...args) {
  const {
      palette: paletteInput = {},
      spacing: spacingInput = {},
      typography: typographyInput = {},
      grid: gridInput = {},
      breakpoints: breakpointsInput = []
    } = overrides,
    other = _objectWithoutProperties(overrides, _excluded);
  const breakpoints = createThemeBreakpoints(breakpointsInput);
  const palette = createThemePalette(paletteInput);
  const spacing = createThemeSpacing(spacingInput);
  const typography = createThemeTypography(typographyInput);
  const grid = createThemeGrid(gridInput, spacing);
  let theme = deepMerge({
    breakpoints,
    palette,
    shadows,
    typography,
    spacing,
    shape,
    zIndex,
    grid
  }, other);
  theme = args.reduce((acc, argument) => deepMerge(acc, argument), theme);
  return theme;
}

export { createTheme, shape, zIndex };
